export default __webpack_public_path__ + "static/media/mz.11cccd05.jpg";